export const OfficeFinanceListState = {
	url: '/finance-option',
	title: 'Office Finance List',
	template: '<finance-options-page></finance-options-page>',
	params: {id: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFinanceOptionsPageMod" */
			'@Containers/office-finance-options/finance-options-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
